import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/roadmap')({
  beforeLoad: () => {
    throw redirect({ to: '/changelog', replace: true, statusCode: 308 });
  },
});
